import { IModuleTranslation } from '@larscom/ngx-translate-module-loader';

const baseTranslateUrl = './assets/i18n/report';

export const report: Array<IModuleTranslation> = [
  {
    baseTranslateUrl,
    moduleName: 'report',
    pathTemplate: '{baseTranslateUrl}/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: 'report-360',
    pathTemplate: '{baseTranslateUrl}/360/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: 'nourish',
    pathTemplate: '{baseTranslateUrl}/nourish/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: 'active',
    pathTemplate: '{baseTranslateUrl}/active/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: 'sportgenomic',
    pathTemplate: '{baseTranslateUrl}/sportgenomic/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: 'persona',
    pathTemplate: '{baseTranslateUrl}/persona/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: 'skin',
    pathTemplate: '{baseTranslateUrl}/skin/{language}'
  }
];
